import {
  useCallback, useEffect, useState,
} from 'react';
import { copy } from '~/_shared/utils/collections/collections';
import {
  type MainMenuItem, MainMenuItems,
} from '~/mainMenu/mainMenuItem.enum';

export const useMainMenuHighlightedItems = () => {
  const [highlightedMenuItems, setHighlightedMenuItems] = useState<ReadonlySet<MainMenuItem>>(new Set());

  const addHighlight = useCallback((menuItem: MainMenuItem) => {
    setHighlightedMenuItems(prevState => copy.andAdd(prevState, [menuItem]));
  }, []);

  const dismissHighlight = useCallback((menuItem: MainMenuItem) => {
    setHighlightedMenuItems(prevState => copy.andRemove(prevState, [menuItem]));
  }, []);

  useEffect(() => {
    addHighlight(MainMenuItems.Help);
  }, [addHighlight]);

  return {
    highlightedMenuItems,
    addHighlight,
    dismissHighlight,
  };
};
